<template>
  <form>
    <div class="lg:grid lg:grid-cols-3 gap-[25px]">
      <div class="lg:col-span-2">
        <div
          class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
        >
          <div
            class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
          >
            <div class="trezo-card-title">
              <h5 class="mb-0">Edit Product</h5>
            </div>
            <div v-if="isExternalProduct" class="bg-yellow-100 text-yellow-800 px-3 py-1 rounded text-xs">
              External product - Read only
            </div>
          </div>
          <div class="trezo-card-content">
            <div v-if="loading" class="flex justify-center py-8">
              <div class="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent"></div>
            </div>
            <div v-else-if="error" class="p-4 bg-red-100 text-red-700 rounded mb-4">
              {{ error }}
            </div>
            <div v-else class="sm:grid sm:grid-cols-2 sm:gap-[25px]">
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Product Title
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.title"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Product Type
                </label>
                <select
                  class="h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
                  v-model="product.product_type"
                  :disabled="isExternalProduct"
                >
                  <option value="">Select</option>
                  <option value="Digital Product">Digital Product</option>
                  <option value="Physical Product">Physical Product</option>
                </select>
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  SKU
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.sku"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Category
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.category"
                  placeholder="Enter category"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Product Description
                </label>
                <textarea
                  v-model="product.description"
                  class="h-[179px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :disabled="isExternalProduct"
                ></textarea>
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Regular Price
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.price"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Sale Price
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.compare_at_price"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Product Link
                </label>
                <input
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.product_link"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Publish Date
                </label>
                <input
                  type="date"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.publish_date"
                  :disabled="isExternalProduct"
                />
              </div>
              <div class="mb-[20px] sm:mb-0" v-if="!isExternalProduct">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Meeting Time (minutes)
                </label>
                <input
                  type="number"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  v-model="product.time"
                  placeholder="Enter meeting duration in minutes"
                />
                <span class="text-xs text-gray-500 dark:text-gray-400 mt-1 block">
                  Specify the meeting duration in minutes
                </span>
              </div>
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  Product Image
                </label>
                <div class="flex items-center gap-4">
                  <div v-if="product.image_link" class="w-24 h-24 rounded overflow-hidden">
                    <img :src="product.image_link" alt="Product image" class="w-full h-full object-cover" />
                  </div>
                  <div id="fileUploader" v-if="!isExternalProduct">
                    <div
                      class="relative flex items-center justify-center overflow-hidden rounded-md py-4 px-[20px] border border-gray-200 dark:border-[#172036]"
                    >
                      <div class="flex items-center justify-center">
                        <div
                          class="w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]"
                        >
                          <i class="ri-upload-2-line"></i>
                        </div>
                        <p class="leading-[1.5]">
                          <strong class="text-black dark:text-white"
                            >Click to upload</strong
                          ><br />
                          new image
                        </p>
                      </div>
                      <input
                        type="file"
                        id="fileInput"
                        class="absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end mt-6" v-if="!loading && !error && !isExternalProduct">
            <button 
              type="button" 
              class="bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors"
              @click="saveProduct"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <div class="lg:col-span-1">
        <div
          class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
        >
          <div
            class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
          >
            <div class="trezo-card-title">
              <h5 class="mb-0">Tags</h5>
            </div>
          </div>
          <div class="trezo-card-content">
            <div class="mb-[20px] md:mb-[25px] last:mb-0">
              <label
                class="mb-[10px] text-black dark:text-white font-medium block"
              >
                Tags
              </label>
              <input
                type="text"
                class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                placeholder="Enter tags separated by commas"
                v-model="tagsInput"
                :disabled="isExternalProduct"
              />
              <div class="flex flex-wrap gap-2 mt-3">
                <span 
                  v-for="(tag, index) in parsedTags" 
                  :key="index"
                  class="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-sm"
                >
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { supabase } from "@/lib/supabaseClient";

interface Product {
  id?: string;
  title: string;
  description: string;
  product_type: string;
  sku: string;
  woocommerce_id: string;
  category: string;
  price: string;
  compare_at_price: string;
  product_link: string;
  image_link: string;
  publish_date: string;
  time: string;
  tags: string[];
  org_id?: string;
}

export default defineComponent({
  name: "EditProduct",
  setup() {
    const route = useRoute();
    const productId = computed(() => route.query.id as string);
    const loading = ref(true);
    const error = ref<string | null>(null);
    const product = ref<Product>({
      title: "",
      description: "",
      product_type: "",
      sku: "",
      woocommerce_id: "",
      category: "",
      price: "",
      compare_at_price: "",
      product_link: "",
      image_link: "",
      publish_date: "",
      time: "",
      tags: [],
    });
    const tagsInput = ref("");

    // Check if product is from external platform and should be read-only
    const isExternalProduct = computed(() => {
      return !!product.value.sku || !!product.value.woocommerce_id;
    });

    // Converts array of tags to comma-separated string for input field
    const parsedTags = computed(() => {
      if (!tagsInput.value) return [];
      return tagsInput.value.split(",").map(tag => tag.trim()).filter(tag => tag);
    });

    // Load product data from the database
    const loadProduct = async () => {
      if (!productId.value) {
        error.value = "No product ID provided";
        loading.value = false;
        return;
      }

      try {
        loading.value = true;
        error.value = null;

        const { data, error: fetchError } = await supabase
          .from("products")
          .select("*")
          .eq("id", productId.value)
          .single();

        if (fetchError) {
          throw fetchError;
        }

        if (!data) {
          throw new Error("Product not found");
        }

        // Convert database data to our Product interface with individual type assertions
        product.value = {
          id: String(data.id),
          title: data.title ? String(data.title) : "",
          description: data.description ? String(data.description) : "",
          product_type: data.product_type ? String(data.product_type) : "",
          sku: data.shopify_id ? String(data.shopify_id) : "",
          woocommerce_id: data.woocommerce_id ? String(data.woocommerce_id) : "",
          category: data.category ? String(data.category) : "",
          price: data.price ? String(data.price) : "",
          compare_at_price: data.compare_at_price ? String(data.compare_at_price) : "",
          product_link: data.product_link ? String(data.product_link) : "",
          image_link: data.image_link ? String(data.image_link) : "",
          publish_date: data.published_at ? new Date(String(data.published_at)).toISOString().split('T')[0] : "",
          time: data.time ? String(data.time) : "",
          tags: Array.isArray(data.tags) ? data.tags.map(tag => String(tag)) : [],
          org_id: data.org_id ? String(data.org_id) : undefined,
        };

        // Set tags input
        tagsInput.value = Array.isArray(data.tags) ? data.tags.map(tag => String(tag)).join(", ") : "";

        loading.value = false;
      } catch (err: any) {
        console.error("Error loading product:", err);
        error.value = `Failed to load product: ${err.message || 'Unknown error'}`;
        loading.value = false;
      }
    };

    // Save product changes to the database
    const saveProduct = async () => {
      try {
        loading.value = true;
        error.value = null;

        // Convert product data to database format
        const updateData = {
          title: product.value.title,
          description: product.value.description,
          product_type: product.value.product_type,
          shopify_id: product.value.sku,
          woocommerce_id: product.value.woocommerce_id,
          category: product.value.category,
          price: product.value.price ? parseFloat(product.value.price) : null,
          compare_at_price: product.value.compare_at_price ? parseFloat(product.value.compare_at_price) : null,
          product_link: product.value.product_link,
          image_link: product.value.image_link,
          published_at: product.value.publish_date ? new Date(product.value.publish_date).toISOString() : null,
          time: product.value.time ? String(product.value.time) : null,
          tags: parsedTags.value,
          updated_at: new Date().toISOString(),
        };

        const { error: updateError } = await supabase
          .from("products")
          .update(updateData)
          .eq("id", productId.value);

        if (updateError) {
          throw updateError;
        }

        alert("Product updated successfully!");
        loading.value = false;
      } catch (err: any) {
        console.error("Error updating product:", err);
        error.value = `Failed to update product: ${err.message || 'Unknown error'}`;
        loading.value = false;
      }
    };

    onMounted(() => {
      loadProduct();
    });

    return {
      product,
      loading,
      error,
      tagsInput,
      parsedTags,
      saveProduct,
      isExternalProduct,
    };
  },
});
</script>
